// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const ImageUrlSizes = require('client-v2/common/records/image-url-sizes')
const {
  defaultReviver,
  keyedReviver
 } = require('client-v2/common/state/revivers')
 // Sibling imports
 const { COLLECTION_FOLLOWING_CHANGE_PENDING } = require('./actions')

const MIX_TYPE_MIXED = 'MIXED'
const MIX_TYPE_USER_MIX = 'USER_MIX'

const VISIBILITY_PUBLIC = 'public'
const VISIBILITY_PRIVATE = 'private'

class CollectionModelRecord extends Immutable.Record({
  'cover_image_url': String(),
  'cover_image_urls': null,
  description: String(),
  'follower_count': Number(),
  'header_image_urls': null,
  id: Number(),
  images: Immutable.List(),
  isFollowing: Boolean(),
  isVerifiedCurator: Boolean(),
  'mix_type': String(MIX_TYPE_USER_MIX),
  'modified_at': String(), // Date-Time as a String
  name: String(),
  'photo_url': String(),
  'posts_count': Number(),
  slug: String(),
  type: String(modelTypes.MIX),
  'user_id': Number(),
  username: String(),
  visibility: String(VISIBILITY_PUBLIC)
}) {
  // No methods
}

CollectionModelRecord.reviver = keyedReviver(CollectionModelRecord, {
  'cover_image_urls': ImageUrlSizes.reviver,
  'header_image_urls': ImageUrlSizes.reviver,
  images: defaultReviver
})

CollectionModelRecord.propTypes = {
  'cover_image_url': PropTypes.string,
  'cover_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
  description: PropTypes.string,
  'follower_count': PropTypes.number,
  'header_image_urls': PropTypes.shape(ImageUrlSizes.propTypes),
  id: PropTypes.number,
  images: PropTypes.arrayOf(PropTypes.string),
  isFollowing: PropTypes.oneOf([
    true,
    false,
    COLLECTION_FOLLOWING_CHANGE_PENDING
  ]),
  isVerifiedCurator: PropTypes.bool,
  'mix_type': PropTypes.string,
  'modified_at': PropTypes.string,
  name: PropTypes.string,
  'photo_url': PropTypes.string,
  'posts_count': PropTypes.number,
  slug: PropTypes.string,
  type: PropTypes.string,
  'user_id': PropTypes.number,
  username: PropTypes.string,
  visibility: PropTypes.oneOf([VISIBILITY_PRIVATE, VISIBILITY_PUBLIC])
}

module.exports = Object.assign(CollectionModelRecord, {
  MIX_TYPE_MIXED,
  MIX_TYPE_USER_MIX,
  VISIBILITY_PRIVATE,
  VISIBILITY_PUBLIC
})
